export default "/assets/images/app-showcase-03.jpg?fb6bfd4f776e022de843a075e14efa96";